import React, { useState, useEffect } from "react";
import ipvLogo from "../../IPV-PNG-logo-White-Cropped 1.png";
import bgimage from "../../Background GIF.gif";
import bgimage1 from "../../Background-image.jpg";
import CountryCodeDropdown from "./CountryCodeDropdown";
import CountryDropdown from "./CountryDropdown";
import ProgressBar from "./ProgressBar";
import info from "../../InfoSaved.png";
import axios from "axios"; // For API calls

const PersonalSection = ({
  formData: initialFormData,
  onNext,
  onSaveDraft,
}) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    countrycode: "",
    country: "",
    PinCode: "",
    contactNumber: "",
    personalEmail: "",
    workEmail: "",
    prefferedEmail: "",
    dob: "",
    linkedinUrl: "",
    panNumber: "",
    referredBy: "",
    currentCity: "",
    postalAddress1: "",
    postalAddress2: "",
    ...initialFormData,
  });

  const [citySuggestions, setCitySuggestions] = useState([]);
  const [cityQuery, setCityQuery] = useState("");
  const [showDraftImage, setShowDraftImage] = useState(false);

  useEffect(() => {
    const savedData = localStorage.getItem("personalData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  // NEW useEffect
useEffect(() => {
  if (!cityQuery || cityQuery.length < 3) {
    setCitySuggestions([]);
    return;
  }

  const delay = setTimeout(() => {
    fetchCitySuggestions(cityQuery);
  }, 500);

  return () => clearTimeout(delay);
}, [cityQuery]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Save updated data to localStorage
    localStorage.setItem(
      "personalData",
      JSON.stringify({ ...formData, [name]: value })
    );

    // Fetch city suggestions for the currentCity input
    if (name === "currentCity") {
    setCityQuery(value);
    }
  };

  const fetchCitySuggestions = async (query) => {
  try {
    const response = await axios.get(
      `https://wft-geo-db.p.rapidapi.com/v1/geo/cities`,
      {
        params: { namePrefix: query, limit: 3 },
        headers: {
          "X-RapidAPI-Key":
            "e1e5409151msh3bd01d694b2976ap1313c9jsnf2f7a863a4f1",
          "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
        },
      }
    );

    setCitySuggestions(response.data.data.map((city) => city.city));
  } catch (error) {
    console.error("Error fetching city suggestions:", error);
    setCitySuggestions([]); // prevent UI crash
  }
};

  const handleCitySelect = (city) => {
    setFormData({ ...formData, currentCity: city });
    setCitySuggestions([]); // Clear suggestions after selection
  };

  const handleSaveDraft = () => {
    localStorage.setItem("professionalData", JSON.stringify(formData));
    setShowDraftImage(true);
    setTimeout(() => setShowDraftImage(false), 3000);
  };

  const handleNext = () => {
    const requiredFields = [
      "firstName",
      "lastName",
      "dob",
      "contactNumber",
      "personalEmail",
      "workEmail",
      "country",
      "currentCity",
    ];

    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(` "${field.replace(/([A-Z])/g, " $1")}" is required.`);
        return;
      }
    }

    // Validation Patterns
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    /*const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; */
    // Email Validation
    if (!emailRegex.test(formData.personalEmail)) {
      alert("Invalid Personal Email. Please enter a valid email address.");
      return;
    }
    if (!emailRegex.test(formData.workEmail)) {
      alert("Invalid Work Email. Please enter a valid email address.");
      return;
    }

    // PAN Validation
    /* if (!panRegex.test(formData.panNumber)) {
      alert('Invalid PAN Number. Please enter a valid PAN in the format ABCDE1234F.');
      return;
    } */

    // If all validations pass
    onNext(formData);
  };
  return (
    <div className="personal-container">
      <div className="main-wrapper">
        <img
          loading="lazy"
          src={bgimage}
          className="background-image"
          alt="background"
        />
        <div className="header-content">
          <img
            loading="lazy"
            src={bgimage1}
            className="background-image"
            alt="background"
          />
          <img
            loading="lazy"
            src={ipvLogo}
            alt="IPV Logo"
            className="ipv-logo"
          />
        </div>
        <div className="form-section">
          <form className="form-layout">
            <ProgressBar currentStep={1} />{" "}
            {/* Current step for Personal Section */}
            <div className="form-container">
              <div className="form-title">Personal Information</div>
              <div className="form-content">
                <div className="form-row">
                  <div className="input-group">
                    <label className="input-label" htmlFor="firstName">
                      First Name*
                    </label>
                    <input
                      id="firstName"
                      name="firstName"
                      className="input-field"
                      type="text"
                      placeholder="First Name"
                      aria-label="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="lastName">
                      Last Name*
                    </label>
                    <input
                      id="lastName"
                      name="lastName"
                      className="input-field"
                      type="text"
                      placeholder="Last Name"
                      aria-label="Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <CountryCodeDropdown
                    value={formData.countrycode}
                    onChange={handleChange}
                  />

                  <div className="input-group">
                    <label className="input-label" htmlFor="contactNumber">
                      Contact Number*
                    </label>
                    <input
                      id="contactNumber"
                      name="contactNumber"
                      className="input-field"
                      type="tel"
                      placeholder="Contact Number"
                      aria-label="Contact Number"
                      value={formData.contactNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="personalEmail">
                      Email Address - Personal*
                    </label>
                    <input
                      id="personalEmail"
                      name="personalEmail"
                      className="input-field"
                      type="email"
                      placeholder="Email Address"
                      aria-label="Personal Email Address"
                      value={formData.personalEmail}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="workEmail">
                      Email Address - Work*
                    </label>
                    <input
                      id="workEmail"
                      name="workEmail"
                      className="input-field"
                      type="email"
                      placeholder="Email Address"
                      aria-label="Work Email Address"
                      value={formData.workEmail}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="prefferedEmail">
                      Preferred Email (Choose between personal and work)*
                    </label>
                    <select
                      id="prefferedEmail"
                      name="prefferedEmail"
                      className="input-field dropdown-select"
                      value={formData.prefferedEmail}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Select Preferred Email
                      </option>
                      <option value="personal">Personal Email</option>
                      <option value="work">Work Email</option>
                    </select>
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="dob">
                      Date of Birth*
                    </label>
                    <input
                      id="dob"
                      name="dob"
                      className="input-field "
                      type="date"
                      aria-label="Date of Birth"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="linkedinUrl">
                      LinkedIn URL
                    </label>
                    <input
                      id="linkedinUrl"
                      name="linkedinUrl"
                      className="input-field"
                      type="url"
                      placeholder="LinkedIn URL"
                      aria-label="LinkedIn URL"
                      value={formData.linkedinUrl}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-group">
                    <label className="input-label" htmlFor="panNumber">
                      PAN Card Number
                    </label>
                    <input
                      id="panNumber"
                      name="panNumber"
                      className="input-field"
                      type="text"
                      placeholder="PAN Card Number"
                      aria-label="PAN Card Number"
                      value={formData.panNumber}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="referredBy">
                      Referred By
                    </label>
                    <input
                      id="referredBy"
                      name="referredBy"
                      className="input-field"
                      type="text"
                      placeholder="Referred By"
                      aria-label="Referred By"
                      value={formData.referredBy}
                      onChange={handleChange}
                    />
                  </div>
                  <CountryDropdown
                    value={formData.country}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="currentCity">
                      Current City*
                    </label>
                    <input
                      id="currentCity"
                      name="currentCity"
                      className="input-field"
                      type="text"
                      placeholder="Start typing your city..."
                      aria-label="Current City"
                      value={formData.currentCity}
                      onChange={handleChange}
                      required
                    />
                    {citySuggestions.length > 0 && (
                      <div className="city-suggestions">
                        {citySuggestions.map((city, index) => (
                          <div
                            key={index}
                            className="city-suggestion"
                            onClick={() => handleCitySelect(city)}
                          >
                            {city}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="input-group">
                    <label className="input-label" htmlFor="PinCode">
                      Pin-Code
                    </label>
                    <input
                      id="PinCode"
                      name="PinCode"
                      className="input-field"
                      type="text"
                      placeholder="Pin-Code"
                      aria-label="Pin-Code"
                      value={formData.Pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="postalAddress1">
                      Postal Address1
                    </label>
                    <textarea
                      id="postalAddress1"
                      name="postalAddress1"
                      className="textarea-field"
                      placeholder="Postal Address 1"
                      aria-label="Postal Address 1"
                      value={formData.postalAddress1}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="postalAddress2">
                      Postal Address2
                    </label>
                    <textarea
                      id="postalAddress2"
                      name="postalAddress2"
                      className="textarea-field"
                      placeholder="Postal Address 2"
                      aria-label="Postal Address 2"
                      value={formData.postalAddress2}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/*  {showDraftImage && (
              <div className="draft-image-container">
                 <img src={info} alt="Draft saved" className="draft-image" />
                   </div>
              )}  */}
            {showDraftImage && (
              <div className="draft-toast-fullscreen">
                <img
                  src={info}
                  alt="Draft saved"
                  className="draft-toast-image"
                />
              </div>
            )}
            <div className="button-wrapper">
              <button
                type="button"
                className="outlined-button"
                onClick={handleSaveDraft}
              >
                Save Draft
              </button>
              <button
                type="button"
                className="filled-button"
                onClick={handleNext}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PersonalSection;
